import REVIEW_HOLTER_BEATS_MUTATION from '@/entities/beat/api/mutations/reviewHolterBeats';
import { createClient } from '@/shared/api';
import type {
  ReviewHolterBeatsMutation,
  ReviewHolterBeatsMutationVariables,
} from '@/shared/api/generated/graphql';

export type ReviewHolterBeatsResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the ReviewHolterBeatsInput GraphQL input once its server-side shape is documented
/**
 * Marks holter beats as reviewed on the server. Runs the reviewHolterBeats mutation and returns its field without inspecting the success flag.
 *
 * @param input - Mutation input naming the beats to review.
 * @returns A promise resolving to the reviewHolterBeats result.
 */
const handleReviewHolterBeats = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<ReviewHolterBeatsMutation, ReviewHolterBeatsMutationVariables>(
    {
      mutation: REVIEW_HOLTER_BEATS_MUTATION,
      variables: {
        input,
      },
    },
  );
  const { data } = result;
  const { reviewHolterBeats } = data || {};
  return reviewHolterBeats;
};

export default handleReviewHolterBeats;
